<script setup lang="ts">
  onMounted(() => {
    document.body.classList.add('fsf-overlay-enabled')
  })

  onUnmounted(() => {
    document.body.classList.remove('fsf-overlay-enabled')
  })
</script>
<template>
  <div
    tabindex="-1"
    class="fixed top-0 z-999 flex size-full items-center justify-center bg-black/60"
  >
    <div>
      <UiPlaneLoader aria-hidden="true" />
    </div>
  </div>
</template>

<style>
  .fsf-overlay-enabled {
    overflow: hidden;
  }
</style>
